import Axios from 'axios';
import React, { useState, useEffect } from 'react';
import { HexpertContextProvider } from '../contexts/HexPertProvider';
import { HexpertPage } from './HexpertPage';
import { CookiesProvider } from 'react-cookie';
import { PageProps } from '../types/hexpertTypes';
import { fieldsToCheckInResult } from '../helpers/formSections';
import { Hexpert as endpoints } from '@services/endpoints';

export type HexpertPageProps = PageProps & {
  startAction?: () => void;
  startForm?: boolean;
};

const Hexpert = () => {
  const [pageProps, setPageProps] = useState<HexpertPageProps>();

  useEffect(() => {
    try {
      Axios.get(endpoints.fetchHexpertPage, {
        params: {
          language: window['lang'],
          url: window?.location?.pathname,
        },
      }).then((page) => {
        const { ContentType, Url, HideRequestData, ...props } = page.data;
        const fieldsToCheck = fieldsToCheckInResult(props?.Forms);
        setPageProps({ ...props, fieldsToCheckInResult: fieldsToCheck });
      });
    } catch (e) {
      console.error(e);
    }
  }, []);

  return (
    <CookiesProvider>
      <HexpertContextProvider pageProps={pageProps}>
        <HexpertPage />
      </HexpertContextProvider>
    </CookiesProvider>
  );
};

export default Hexpert;
